import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2a70264e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=2a70264e&prod&scoped=true&lang=css"
import style1 from "./Header.vue?vue&type=style&index=1&id=2a70264e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70264e",
  null
  
)

export default component.exports